import React, { useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import classNames from "classnames";
import Icon from "../../elements/icon";

const PickupLocationOptions = ({ onTouchPointClick, touchPoint, isActive }) => {
  const { id, name, city, address, zipCode, contactPerson, contact } = touchPoint;
  const listClass = classNames("pickup-location-list__item", { "pickup-location-list__item___selected": isActive });

  return (
    <div>
      <li
        className={listClass}
        onClick={evt => {
          onTouchPointClick(evt, touchPoint);
        }}
      >
        <div className="deliveryWrap">
          <div>
            <p className="city">{name}</p>
            <p className="adress">
              {address}, {city}
            </p>
          </div>
          <div>
            <span className={isActive ? "showDone" : "hideDone"}>
              <Icon className="checkMark" name="Done" />
            </span>
          </div>
        </div>
      </li>
    </div>
  );
};

export default PickupLocationOptions;
